import { APIClient } from "../api_helper";
import * as url from "../url_helper";

const api = new APIClient();

export const deviceAdaptAPI = (id) => {
    return api.get(url.DEVICE_ADAPT(id));
}
export const deviceAdaptResourceAPI = () => {
    return api.get(url.DEVICE_ADAPT_RESOURCE());
}

export const deviceAdaptStartAPI = (data) => {
    return api.create(url.DEVICE_ADAPT_START(), data);
}

export const deviceAdaptUpdateAPI = (id, data) => {
    return api.put(url.DEVICE_ADAPT_UPDATE(id), data);
}

export const deviceAdaptStepAPI = (id, data) => {
    return api.create(url.DEVICE_ADAPT_STEP(id), data);
}

export const deviceAdaptPreviousStepAPI = (id, stepId) => {
    return api.get(url.DEVICE_ADAPT_PREVIOUS_STEP(id, stepId));
}
